import { render } from "./websiteClient.vue?vue&type=template&id=5a512fba&scoped=true"
import script from "./websiteClient.vue?vue&type=script&lang=js"
export * from "./websiteClient.vue?vue&type=script&lang=js"

import "./websiteClient.vue?vue&type=style&index=0&id=5a512fba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a512fba"]])

export default __exports__